export default "__VITE_ASSET__zOC7_LIn__"